import * as Colors from "../../../../globalStyles/administratorColors";

export const imgLogo = {
	width: "150px",
	height: "150px",
	borderRadius: "25px",
	padding: "10px",
};

export const innerContainer = {
	backgroundColor: Colors.secondary,
	color: "black",
};

export const loginBtns = {
	color: Colors.accent,
	fontWeight: "bold",
};
